import React, { useRef, useState, useContext } from "react";
import { BsCalendar, BsGeoAlt, BsPeople } from "react-icons/bs";
import { FaHandHoldingHeart, FaUsers, FaBullhorn } from "react-icons/fa";
import ActivityImg1 from "../assets/Gangapur_event.jpg";
import ActivityImg2 from "../assets/krushi.png";
import ActivityImg3 from "../assets/krushi-vibhag.png";
import ActivityImg4 from "../assets/sans_vibhag.png";
// import ActivityImg5 from "../assets/logo.png";
// import ActivityImg6 from "../assets/moredada_hospital.jpg";


import DonateButton from "../components/Donate";
import VideoThumbnail from "../assets/Akhil Bhartiya Shree Swami Samarth Gurupeeth, Trimbakeshwar.mp4";
import "./Activities.css";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import Header from "../components/Layout/Header";
import ScrollAnimation from "../components/ScrollAnimations";
import Slider from "react-slick";
import { FiDownload } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";

const translations = {
  en: {
    header: "Activities & Events",
    breadcrumb: "Home / Activities & Events",
    aboutTitle: "About This Activity",
    aboutDesc:
      "Our organization conducts various social and spiritual activities throughout the year, serving the community with dedication and compassion. Each event is designed to uplift society and spread the teachings of Swami Samarth.",
    stats: [
      "Touching lives of thousands through meaningful community service",
      "Regular events conducted across multiple villages and cities",
      "Join us in making a difference - volunteers always welcome",
    ],
    detailsTitle: "Event Details",
    eventDate: "Event Date",
    location: "Location",
    participants: "Expected Participants",
    contactTitle: "Get Involved",
    volunteerText: "Become a Volunteer",
    supportText: "Support This Cause",
    registerText: "Register for Event",
    gallery: "Event Gallery",
    view: "View",
    home: "Home",
    upcomingEvents: "Upcoming Events",
    pastEvents: "Past Events",
  },
  mr: {
    header: "कार्यक्रम व इव्हेंट्स",
    breadcrumb: "मुख्यपृष्ठ / कार्यक्रम व इव्हेंट्स",
    aboutTitle: "या कार्यक्रमाबद्दल",
    aboutDesc:
      "आमची संस्था वर्षभर विविध सामाजिक आणि आध्यात्मिक कार्यक्रम आयोजित करते, समर्पण आणि करुणेने समाजाची सेवा करते. प्रत्येक कार्यक्रम समाजाला उंचावण्यासाठी आणि स्वामी समर्थांची शिकवण पसरवण्यासाठी डिझाइन केलेला आहे.",
    stats: [
      "अर्थपूर्ण सामुदायिक सेवेद्वारे हजारो जीवनांना स्पर्श करणे",
      "अनेक गावे आणि शहरांमध्ये नियमित कार्यक्रम आयोजित",
      "फरक करण्यात आमच्यासोबत सामील व्हा - स्वयंसेवकांचे नेहमी स्वागत",
    ],
    detailsTitle: "कार्यक्रमाचा तपशील",
    eventDate: "कार्यक्रमाची तारीख",
    location: "स्थान",
    participants: "अपेक्षित सहभागी",
    contactTitle: "सहभागी व्हा",
    volunteerText: "स्वयंसेवक बना",
    supportText: "या कार्यक्रमाला पाठिंबा द्या",
    registerText: "कार्यक्रमासाठी नोंदणी करा",
    gallery: "कार्यक्रम गॅलरी",
    view: "पहा",
    home: "मुख्यपृष्ठ",
    upcomingEvents: "आगामी कार्यक्रम",
    pastEvents: "मागील कार्यक्रम",
  },
};

export default function Activities() {
  const { lang } = useContext(LanguageContext);
  const [zoomImg, setZoomImg] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const t = translations[lang];

  const images = [ActivityImg1, ActivityImg2, ActivityImg3, ActivityImg4];
  const videoRef = useRef(null);

  // Handle video play/pause
  const handleVideoClick = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  // Listen to video play/pause events
  const handlePlay = () => setIsPlaying(true);
  const handlePause = () => setIsPlaying(false);

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(3, images.length),
    slidesToScroll: 1,
    arrows: images.length > 3,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 900,
        settings: { slidesToShow: 2, arrows: false },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1, arrows: false, dots: true },
      },
    ],
  };

  return (
    <div className="activity-page">
      {/* Header */}
      <Header />

      {/* Page Header with Breadcrumb */}
      <ScrollAnimation animation="fade-down">
        <div className="activity-header">
          <div className="header-center">
            <div className="breadcrumb">
              <Link to="/">{t.home}</Link> &gt; <span>{t.header}</span>
            </div>
            <h1>{t.header}</h1>
          </div>
        </div>
      </ScrollAnimation>

      {/* Main Content */}
      <main className="activity-main">
        <div className="info-video-container">
          {/* Left Side: Info */}
          <div className="activity-info-left">
            <ScrollAnimation animation="fade-up" delay={100}>
              <h2>{t.aboutTitle}</h2>
              <p>{t.aboutDesc}</p>
            </ScrollAnimation>

            {/* Highlight Info */}
            <ScrollAnimation animation="fade-up" delay={200}>
              <div className="activity-stats">
                <ScrollAnimation animation="slide-left" delay={100}>
                  <div className="stat-card">
                    <FaHandHoldingHeart className="stat-icon" />
                    <p>{t.stats[0]}</p>
                  </div>
                </ScrollAnimation>

                <ScrollAnimation animation="slide-left" delay={200}>
                  <div className="stat-card">
                    <FaBullhorn className="stat-icon" />
                    <p>{t.stats[1]}</p>
                  </div>
                </ScrollAnimation>

                <ScrollAnimation animation="slide-left" delay={300}>
                  <div className="stat-card">
                    <FaUsers className="stat-icon" />
                    <p>{t.stats[2]}</p>
                  </div>
                </ScrollAnimation>
              </div>
            </ScrollAnimation>

            {/* Event Details */}
            <ScrollAnimation animation="fade-up" delay={300}>
              <h3>{t.detailsTitle}</h3>
              <div className="event-details-cards">
                <ScrollAnimation animation="slide-right" delay={100}>
                  <div className="detail-card">
                    <BsCalendar className="icon icon-date" />
                    <div>
                      <strong>{t.eventDate}</strong>
                      <p>12 August 2025</p>
                    </div>
                  </div>
                </ScrollAnimation>

                <ScrollAnimation animation="slide-right" delay={200}>
                  <div className="detail-card">
                    <BsGeoAlt className="icon icon-location" />
                    <div>
                      <strong>{t.location}</strong>
                      <p>Trimbakeshwar, Nashik, Maharashtra</p>
                    </div>
                  </div>
                </ScrollAnimation>

                <ScrollAnimation animation="slide-right" delay={300}>
                  <div className="detail-card">
                    <BsPeople className="icon icon-participants" />
                    <div>
                      <strong>{t.participants}</strong>
                      <p>1000+ People</p>
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
            </ScrollAnimation>

            <ScrollAnimation animation="fade-up" delay={400}>
              <h3>{t.contactTitle}</h3>
              <div className="activity-buttons">
                <button className="btn-action btn-volunteer">
                  {t.volunteerText}
                </button>
                <button className="btn-action btn-register">
                  {t.registerText}
                </button>
                <Link to="/donation">
                  <DonateButton />
                </Link>
              </div>
            </ScrollAnimation>
          </div>

          {/* Right Side: Video */}
          <ScrollAnimation animation="fade-left" delay={200}>
            <div className="activity-video-card">
              <video
                ref={videoRef}
                src={VideoThumbnail}
                poster={ActivityImg1}
                className="activity-video"
                playsInline
                controls
                onPlay={handlePlay}
                onPause={handlePause}
                onEnded={handlePause}
              />
              {!isPlaying && (
                <div className="video-overlay" onClick={handleVideoClick}>
                  <span>▶ Watch Event Highlights</span>
                </div>
              )}
            </div>
          </ScrollAnimation>
        </div>

        {/* Gallery Section */}
        <ScrollAnimation animation="fade-up" delay={500}>
          <section className="activity-gallery">
            <h2>{t.gallery}</h2>
            <Slider {...sliderSettings} className="gallery-slider">
              {images.map((img, i) => (
                <div key={i} className="gallery-slide-wrapper">
                  <div
                    className="gallery-item"
                    onClick={() => setZoomImg(img)}
                  >
                    <img src={img} alt={`Activity ${i + 1}`} />
                    <div className="gallery-overlay">{t.view}</div>
                  </div>
                </div>
              ))}
            </Slider>

            {/* Zoom Modal */}
            {zoomImg && (
              <div className="zoom-modal" onClick={() => setZoomImg(null)}>
                <AiOutlineClose
                  className="zoom-close-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setZoomImg(null);
                  }}
                  size={28}
                />

                <img src={zoomImg} alt="Zoomed" />
                <a
                  href={zoomImg}
                  download
                  className="download-icon"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FiDownload size={24} />
                </a>
              </div>
            )}
          </section>
        </ScrollAnimation>
      </main>
    </div>
  );
}